/* tslint:disable */
/* eslint-disable */
/**
 * users
 * users
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
import type { OrganizationMfaSettings } from './OrganizationMfaSettings';
import {
    OrganizationMfaSettingsFromJSON,
    OrganizationMfaSettingsFromJSONTyped,
    OrganizationMfaSettingsToJSON,
    OrganizationMfaSettingsToJSONTyped,
} from './OrganizationMfaSettings';

/**
 * 
 * @export
 * @interface GetOrganizationMfaSettings200Response
 */
export interface GetOrganizationMfaSettings200Response {
    /**
     * 
     */
    data?: OrganizationMfaSettings;
}

/**
 * Check if a given object implements the GetOrganizationMfaSettings200Response interface.
 */
export function instanceOfGetOrganizationMfaSettings200Response(value: object): value is GetOrganizationMfaSettings200Response {
    return true;
}

export function GetOrganizationMfaSettings200ResponseFromJSON(json: any): GetOrganizationMfaSettings200Response {
    return GetOrganizationMfaSettings200ResponseFromJSONTyped(json, false);
}

export function GetOrganizationMfaSettings200ResponseFromJSONTyped(json: any, ignoreDiscriminator: boolean): GetOrganizationMfaSettings200Response {
    if (json == null) {
        return json;
    }
    return {
        
        'data': json['data'] == null ? undefined : OrganizationMfaSettingsFromJSON(json['data']),
    };
}

export function GetOrganizationMfaSettings200ResponseToJSON(json: any): GetOrganizationMfaSettings200Response {
    return GetOrganizationMfaSettings200ResponseToJSONTyped(json, false);
}

export function GetOrganizationMfaSettings200ResponseToJSONTyped(value?: GetOrganizationMfaSettings200Response | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'data': OrganizationMfaSettingsToJSON(value['data']),
    };
}

